import VesselColour from "../../Enums/VesselColour";
const VesselIcon = {}; // vessel icon names as found in the mapbox style
VesselIcon[VesselColour.WHITE] = {
	standard: "vessel-white-standard",
	highlight: "vessel-white-highlight",
	circleStandard: "vessel-white-circle",
	circleHighlight: "vessel-white-circle-highlight"
};
VesselIcon[VesselColour.BLACK] = {
	standard: "vessel-black-standard",
	highlight: "vessel-black-highlight",
	circleStandard: "vessel-black-circle",
	circleHighlight: "vessel-black-circle-highlight"
};
VesselIcon[VesselColour.BROWN] = {
	standard: "vessel-brown-standard",
	highlight: "vessel-brown-highlight",
	circleStandard: "vessel-brown-circle",
	circleHighlight: "vessel-brown-circle-highlight"
};
VesselIcon[VesselColour.DARKBLUE] = {
	standard: "vessel-darkblue-standard",
	highlight: "vessel-darkblue-highlight",
	circleStandard: "vessel-darkblue-circle",
	circleHighlight: "vessel-darkblue-circle-highlight"
};
VesselIcon[VesselColour.DARKGREEN] = {
	standard: "vessel-darkgreen-standard",
	highlight: "vessel-darkgreen-highlight",
	circleStandard: "vessel-darkgreen-circle",
	circleHighlight: "vessel-darkgreen-circle-highlight"
};
VesselIcon[VesselColour.DARKRED] = {
	standard: "vessel-darkred-standard",
	highlight: "vessel-darkred-highlight",
	circleStandard: "vessel-darkred-circle",
	circleHighlight: "vessel-darkred-circle-highlight"
};
VesselIcon[VesselColour.GRAY] = {
	standard: "vessel-gray-standard",
	highlight: "vessel-gray-highlight",
	circleStandard: "vessel-gray-circle",
	circleHighlight: "vessel-gray-circle-highlight"
};
VesselIcon[VesselColour.LIGHTBLUE] = {
	standard: "vessel-lightblue-standard",
	highlight: "vessel-lightblue-highlight",
	circleStandard: "vessel-lightblue-circle",
	circleHighlight: "vessel-lightblue-circle-highlight"
};
VesselIcon[VesselColour.LIGHTGREEN] = {
	standard: "vessel-lightgreen-standard",
	highlight: "vessel-lightgreen-highlight",
	circleStandard: "vessel-lightgreen-circle",
	circleHighlight: "vessel-lightgreen-circle-highlight"
};
VesselIcon[VesselColour.LIGHTRED] = {
	standard: "vessel-lightred-standard",
	highlight: "vessel-lightred-highlight",
	circleStandard: "vessel-lightred-circle",
	circleHighlight: "vessel-lightred-circle-highlight"
};
VesselIcon[VesselColour.MAGENTA] = {
	standard: "vessel-magenta-standard",
	highlight: "vessel-magenta-highlight",
	circleStandard: "vessel-magenta-circle",
	circleHighlight: "vessel-magenta-circle-highlight"
};
VesselIcon[VesselColour.ORANGE] = {
	standard: "vessel-orange-standard",
	highlight: "vessel-orange-highlight",
	circleStandard: "vessel-orange-circle",
	circleHighlight: "vessel-orange-circle-highlight"
};
VesselIcon[VesselColour.PURPLE] = {
	standard: "vessel-purple-standard",
	highlight: "vessel-purple-highlight",
	circleStandard: "vessel-purple-circle",
	circleHighlight: "vessel-purple-circle-highlight"
};
VesselIcon[VesselColour.SALMON] = {
	standard: "vessel-salmon-standard",
	highlight: "vessel-salmon-highlight",
	circleStandard: "vessel-salmon-circle",
	circleHighlight: "vessel-salmon-circle-highlight"
};
VesselIcon[VesselColour.VIOLET] = {
	standard: "vessel-violet-standard",
	highlight: "vessel-violet-highlight",
	circleStandard: "vessel-violet-circle",
	circleHighlight: "vessel-violet-circle-highlight"
};
VesselIcon[VesselColour.YELLOW] = {
	standard: "vessel-yellow-standard",
	highlight: "vessel-yellow-highlight",
	circleStandard: "vessel-yellow-circle",
	circleHighlight: "vessel-yellow-circle-highlight"
};
VesselIcon.helpers = {
	toColor: (icon) => {
		const parts = icon.split("-");
		const color = parts[1];
		if (color === "lightred") {
			return "red";
		}
		return color;
	}
};
export default VesselIcon;
